<template>
  <!-- <div class="development-history">
    <el-timeline>
      <el-timeline-item
        v-for="(item, index) in mydata.developmentHistoryArr"
        :timestamp="item.year"
        placement="top"
        color="#009DE0"
        :key="index"
        :class="index % 2 !== 0 ? 'go-left' : ''"
      >
        <el-card>
          <h4>{{ item.title }}</h4>
          <p>
            {{ item.intro }}
          </p>
          <img v-complete:src="item.image" />
        </el-card>
      </el-timeline-item>
    </el-timeline>
  </div> -->

  <div class="development-history">
    <div
      class="box-history"
      v-for="(item, index) in mydata.developmentHistoryArr"
      :key="index"
    >
      <p class="p-time">{{ item.year }}</p>

      <div class="d-content">
        <p>{{ item.title }}</p>
        <p>{{ item.intro }}</p>
        <img v-complete:src="item.image" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive } from "@vue/reactivity";

// 引入接口
import { developmentHistory } from "@/api/walkIntroTianLi/developmentHistoryTwo/index.js";

//视频
import myXgplayer from "@/components/myXgplayer/index.vue";

import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  // 图片基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,

  developmentHistoryArr: [], //发展历程
});

////////////////////////////////////////////////////////////

// 获取发展历程
function developmentList() {
  developmentHistory({}).then((res) => {
    // console.log("发展历程", res.data);
    mydata.developmentHistoryArr = res.data;
  });
}

// 调用函数
developmentList();
</script>

<style scoped lang="scss">
.development-history{
  //  background: #f9f9f9;
  // padding-bottom:40px;
}

.box-history {
  width: 343px;
  margin: 0 auto;
  margin-top: 16px;
  margin-bottom: 30px;
  
  // border: 1px solid rgb(10, 243, 49);
 
  .p-time {
    font-size: 24px;
    font-weight: 700;
    color: #009de0;
    margin-bottom:8px;
  }

  .d-content {

    width: 343px;
    padding:16px;
    background: #ffffff !important;
    border-radius: 8px;
    background-color:#e7e7e546 ;
    // box-shadow: 1px 1px 1px 1px #e7e7e563;
    box-shadow: 0px 5px 40px 0px rgba(0, 0, 0, 0.0509803922);
    > p:first-of-type {
      font-size: 18px;
      font-weight: 700;
      margin-bottom:5px;
    }
    > p:nth-of-type(2) {
      font-size: 14px;
      margin-bottom:16px;
    }
    >img{
      width:100%;
      height:201px;
    }
  }
 
}

.box-history:last-of-type{
   margin-bottom: 40px;
}
</style>
